import * as yup from "yup";
import { TFunction } from "i18next";

export type TAddEducationalProgramForm = {
  position: number[];
};

export const addEducationalProgramValidationSchema = (t: TFunction) =>
  yup.object().shape({
    position: yup
      .array()
      .of(yup.number().required(t("validation.required")))
      .min(1, t("validation.required"))
      .required(t("validation.required")),
  });
